import React from "react";
import { cx } from "@emotion/css";
import { useMemo } from "react";

import { isNotUndefined } from "@/shared/FunctionCore";
import { classCombinerFromPrefix, RenderableData, renderIdentifierGeneric } from "@/app/pages/upik/resources/RenderIdentifier";
import { UpikContainerProps } from "@/app/pages/upik/resources/interfacesData";
import * as ContainerStyles from "@/app/pages/upik/styles/ContainerStyles.module.scss";
import * as SearchResultStyles from "@/app/pages/upik/styles/SearchResultStyles.module.scss";
import { Header } from "@/app/pages/upik/components/Header";
import { SearchTabs } from "@/app/pages/upik/components/SearchTabs";
import { Footer } from "@/app/pages/upik/components/Footer";
import { contactUpikRoutes, TermsOfUseUpikRoutes } from "@/app/pages/upik/resources/constant";
import { TermsOfUse } from "@/app/pages/upik/components/TermsOfUse";
import { ContactUpik } from "@/app/pages/upik/components/CcontactUpik";
import { browserTitleContent, metaDescriptionUpik } from "../resources/content";
import MetaDataTags from "@/components/metaDataTags/MetaDataTags";

const styles = SearchResultStyles;
const classCombiner = classCombinerFromPrefix("850cb40c5e9711c2");
const stylesContainer = ContainerStyles;
const classCombinerContainer = classCombinerFromPrefix("a43bb12b864a3f8r");

export const UpikContainer = (props: UpikContainerProps): JSX.Element => {

    const pageUrlInfo = useMemo(() => {
        if (isNotUndefined(props.currentPagePath)) {
            let initialPageUrl = props.currentPagePath.replace(".html", "");
            const language = props.currentPagePath.includes("-en") ? "en" : "de";
            let otherLanguagePageUrl = language === "en" ? initialPageUrl.replace("-en", "") : `${initialPageUrl}-en`;
            return { "language": language, "otherLanguagePageUrl": otherLanguagePageUrl };
        }
        return { "language": "de", "otherLanguagePageUrl": "#" };
    }, [props.currentPagePath]);

    return (
        <>
            {props?.currentPagePath &&
                (contactUpikRoutes.some(term => props?.currentPagePath?.includes(term)) ? (
                    <>
                        <MetaDataTags
			                title={pageUrlInfo?.language === 'de' ? browserTitleContent.de.contactUpik : browserTitleContent.en.contactUpik}
			                description={pageUrlInfo?.language === 'de' ? metaDescriptionUpik.de.contactUpik : metaDescriptionUpik.en.contactUpik}
		                />
                        <ContactUpik language={pageUrlInfo?.language} />
                    </>
                ) : TermsOfUseUpikRoutes.some(term => props?.currentPagePath?.includes(term)) ? (
                    <>
                        <MetaDataTags
			                title={pageUrlInfo?.language === 'de' ? browserTitleContent.de.termsOfUseUpik : browserTitleContent.en.termsOfUseUpik}
			                description={pageUrlInfo?.language === 'de' ? metaDescriptionUpik.de.termsOfUseUpik : metaDescriptionUpik.en.termsOfUseUpik}
		                />
                        <TermsOfUse language={pageUrlInfo?.language} />
                        <Footer {...pageUrlInfo} currentPagePath={props.currentPagePath} />
                    </>
                ) : (
                    <>
                        <MetaDataTags
			                title={browserTitleContent.en.upikDashbord}
			                description={pageUrlInfo?.language === 'de' ? metaDescriptionUpik.de.upikDashbord : metaDescriptionUpik.en.upikDashbord}
		                />
                        <Header
                            {...pageUrlInfo}
                            currentPagePath={props.currentPagePath}
                        />

                        <div className={cx(classCombinerContainer(stylesContainer, ("upik-container-bg-img")))}>
                            <div className={cx(classCombiner(styles, "upik-search-result-container"), classCombiner(styles, "search-result-parent"))}>
                                <div
                                    className={cx(
                                        "business-directory-redesign-container",
                                        classCombiner(styles, "container"),
                                        classCombiner(styles, "upik-search-result-card")
                                    )}>
                                    <SearchTabs
                                        {...props}
                                        language={pageUrlInfo.language}
                                    />
                                </div>
                            </div>
                        </div>
                        <Footer {...pageUrlInfo} currentPagePath={props.currentPagePath} />
                    </>
                ))}
        </>
    );
};

export const upikContainer = (renderableData: RenderableData<UpikContainerProps>): void =>
    renderIdentifierGeneric(UpikContainer, renderableData);
